import { render, staticRenderFns } from "./BtnResort.vue?vue&type=template&id=1d19a512&scoped=true&lang=pug&"
import script from "./BtnResort.vue?vue&type=script&lang=js&"
export * from "./BtnResort.vue?vue&type=script&lang=js&"
import style0 from "./BtnResort.vue?vue&type=style&index=0&id=1d19a512&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d19a512",
  null
  
)

export default component.exports